<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>
    <div class="container-fluid mt--8">
      <div class="card shadow">
        <div class="row p-3">
          <div class="col-lg-8 col-8 mb-1">
            <button
              v-on:click="onDetailRow"
              :disabled="!showActionDetail"
              class="btn btn-primary ml-2"
            >
              <i class="fa fa-edit"></i> Details
            </button>
            <download-excel
              :data="selectedItems"
              name="UPCConsumerBlockReport-selected-report.csv"
              type="csv"
              style="float: left"
            >
              <button class="btn btn-primary ml-2">
                <i class="fa fa-download"></i>
                Export selected
              </button>
            </download-excel>
          </div>
        </div>
        <div v-if="message">
          <base-alert :type="message.type" :dismissible="true">{{
            message.message
          }}</base-alert>
        </div>
        <div v-if="deleteMessages">
          <base-alert
            :type="message.type"
            :dismissible="true"
            v-for="(row, index) in deleteMessages"
            :key="index"
            >{{ row.message }}</base-alert
          >
        </div>
        <div class="accordion p-3" role="tablist">
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button
                block
                v-b-toggle.accordion-1
                variant="neutral"
                class="text-left"
                >Search Transaction Criteria
                <span class="when-opened ml-3">
                  <i class="fa fa-arrow-down" />
                </span>
                <span class="when-closed ml-3">
                  <i class="fa fa-arrow-right" />
                </span>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-1"
              visible
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <div class="mb-3 row">
                  <label class="col-sm-2 col-form-label form-control-label">
                    brand
                  </label>
                  <div class="col-sm-2">
                    <b-form-select
                      id="input-3"
                      v-model="BrandCodeModel"
                      :options="brandCodeOption"
                      class="mx-input"
                      required
                    ></b-form-select>
                  </div>
                </div>
                <div class="mb-3 row">
                  <label class="col-sm-2 col-form-label form-control-label">
                    transaction date
                  </label>
                  <div class="col-sm-3">
                    <date-picker
                      v-model="timeFilter"
                      range
                      confirm-text="confirm"
                      confirm
                      editable
                      clearable
                      :default-value="timeFilter"
                      value-type="YYYY-MM-DD"
                      @confirm="onDateFilterSubmit"
                      id="DateRange"
                    ></date-picker>
                  </div>
                </div>
                <div class="mb-4 row">
                  <label class="col-sm-2 col-form-label form-control-label">
                    query by
                  </label>
                  <div class="col-sm-2">
                    <b-form-select
                      id="input-3"
                      v-model="PropertyFilterModel"
                      :options="PropertyFilterList"
                      class="mx-input"
                      required
                    ></b-form-select>
                  </div>
                  <label
                    class="col-form-label form-control-label text-sm pl-0"
                    >{{ ConditionFilterModel }}</label
                  >
                  <div class="col-sm-4 ml-0">
                    <input
                      v-model="ValueFilterModel"
                      class="form-control mx-input"
                    />
                  </div>
                </div>
                <div class="mb-4 row">
                  <label class="col-sm-2 col-form-label form-control-label">
                   Promotion Type
                  </label>
                  <div class="col-sm-3">
                    <b-form-select
                      id="input-3"
                      v-model="PromotionTypeFilterModel"
                      :options="PromotionTypeFilterOption"
                      class="mx-input"
                      required
                    ></b-form-select>
                  </div>
                </div>
                <div class="mt-3 row">
                  <div class="col-sm-2 col-form-label form-control-label"></div>
                  <button
                    v-on:click="onSearchFilter"
                    class="btn btn-warning ml-3"
                  >
                    <i class="fa fa-search"></i> Search
                  </button>
                  <button
                    v-on:click="onSearchExport"
                    class="btn btn-warning ml-2"
                  >
                    <i class="fa fa-download"></i> Search and Export
                  </button>
                  <button
                    v-on:click="onResetFilter"
                    class="btn btn-neutral ml-2"
                  >
                    <i class="fa fa-times"></i> reset query
                  </button>
                </div>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
        <vue-bootstrap4-table
          :rows="rows"
          :columns="columns"
          :config="config"
          :classes="classes"
          @on-select-row="onSelectRow"
          @on-unselect-row="onSelectRow"
          @on-all-select-rows="onSelectAllRow"
        >
        <template slot="action_button" slot-scope="props">
          <button
              :disabled="disableUnlockButton(props.row)"
              v-on:click="unblockUser(props.cell_value)"
              v-if="is_allowed_unblock"
              class="btn btn-primary ml-2"
            >
            Unblock 
            </button>
        </template>
        <template slot="promotion_type_column" slot-scope="props">
            <label v-if="props.cell_value == 3"> UPC Input - Lifetime</label>
            <label v-if="props.cell_value == 4"> UPC Custom Insert</label>
            <label v-if="props.cell_value == 9"> UPC Input Regular</label>
            <label v-if="props.cell_value == 50"> UPC Custom Insert With Raffle </label>
          </template>
        </vue-bootstrap4-table>
        <div class="overflow-auto mt-3">
          <nav>
            <ul class="pagination b-pagination justify-content-center">
              <li class="col-12 p-0 pl-2">
                <label class="ml-2">Go to page: </label>
                <b-form-select
                  size="sm"
                  class="col-1 ml-2 mr-2"
                  v-model="currentPage"
                  :options="arrayPages()"
                  required
                ></b-form-select>
                <b-button
                  v-if="currentPage != 1"
                  v-on:click="onLoadData(currentPage - 1)"
                  class="ml-3 mr-1 btn-sm btn-neutral"
                >
                  <i class="fa fa-less-than"></i>
                </b-button>
                <b-button
                  v-if="currentPage != totalPages"
                  v-on:click="onLoadData(currentPage + 1)"
                  class="ml-1 mr-3 btn-sm btn-neutral"
                >
                  <i class="fa fa-greater-than"></i>
                </b-button>

                <label class="ml-2">Show rows: </label>
                <b-form-select
                  size="sm"
                  class="col-1 ml-2 mr-2"
                  v-model="itemPerPage"
                  :options="ItemPerPageList"
                  required
                ></b-form-select>
                <label
                  >{{ itemPerPage * currentPage - itemPerPage + 1 }} -
                  {{
                    currentPage == totalPages
                      ? totalItems
                      : itemPerPage * currentPage
                  }}
                  of {{ totalItems }}
                </label>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
    <modal :show.sync="showModalCreate" modal-classes="modal-md">
      <h3 slot="header" class="modal-title" id="modal-title-default">
        {{ this.titlePopup }} UPC Consumer Block Report
      </h3>
      <table class="table table-striped">
        <tr>
          <td>Brand</td>
          <td>{{ this.UPCConsumerBlockModel.brand_code }}</td>
        </tr>        
        <tr>
          <td>Promotion Id</td>
          <td>{{ this.UPCConsumerBlockModel.promo_id }}</td>
        </tr>
        <tr>
          <td>Promotion Type</td>
          <td>{{ this.UPCConsumerBlockModel.promotion_type }}</td>
        </tr>
        <tr>
          <td>User Raffle Id</td>
          <td>{{ this.UPCConsumerBlockModel.user_raffle_id }}</td>
        </tr>
        <tr>
          <td>Block Time Limit UTC</td>
          <td>{{ this.UPCConsumerBlockModel.block_time_limit_utc }}</td>
        </tr>
        <tr>
          <td>Block Type</td>
          <td>{{ this.UPCConsumerBlockModel.block_type }}</td>
        </tr>
        <tr>
          <td>Block Reason</td>
          <td>{{ this.UPCConsumerBlockModel.block_reason }}</td>
        </tr>
        <tr>
          <td>Is Unlock</td>
          <td>{{ this.UPCConsumerBlockModel.is_unlocked }}</td>
        </tr>
        <tr>
          <td>Unblock By User</td>
          <td>{{ this.UPCConsumerBlockModel.unblock_by_user }}</td>
        </tr>
        <tr>
          <td>Created Date</td>
          <td>{{ this.UPCConsumerBlockModel.created_date_utc }}</td>
        </tr>
        <tr></tr>
      </table>
    </modal>
  </div>
</template>
<script>
import VueBootstrap4Table from "vue-bootstrap4-table";
import { API } from "aws-amplify";
import * as queries from "../graphql/queries";
import "vue2-datepicker/index.css";
// import BarChart from "../components/Charts/BarChart";
import NProgress from "nprogress";
import api_loyalty from "../api/api";
import axios from "axios";

export default {
  name: "configList",
  data() {
    return {
      SummaryData: [],
      // chartDate: [],
      // chartDataSource: { labels: [], datasets: [] },
      totalItems: 0,
      totalPages: 0,
      isCompletedLoadAllItems: false,
      nextToken: null,
      ListNextToken: [],
      itemPerPage: 50,
      ItemPerPageList: [50, 100, 500, 1000, 5000],
      currentPage: 1,
      IsConditionFilterDisabled: true,
      BrandCodeModel: "PHFortune",
      DateRangeModel: null,
      ValueFilterModel: "",
      PropertyFilterModel: "promo_id",
      ConditionFilterModel: "is",
      PromotionTypeFilterModel:"",
      PropertyFilterList: [
        { text: "Promo Id", value: "promo_id" },
        { text: "User Raffle Id", value: "user_raffle_id" },
      ],
      PromotionTypeFilterOption: [
        { text: "UPC Input - Lifetime", value: "3" },
        { text: "UPC Custom Insert", value: "4" },
        { text: "UPC Input Regular", value: "9" },
        { text: "UPC Custom Insert With Raffle", value: "50" },
      ],
      showLoadButton: true,
      timeFilter: [],
      filter: {
        brand_code: "",
        promo_id: "",
        promotion_type: "",
        user_raffle_id: "",
        start_date: "",
      },
      allTransaction: [],
      deleteMessages: [],
      showConfirmationModal: false,
      selectedItems: [],
      showActionDetail: false,
      showActionDelete: false,
      brandCodeOption: [],
      titlePopup: "Details",
      message: null,

      UPCConsumerBlockModel: {
        brand_code: "",
        promo_id:"",
        promotion_type:"",
        user_raffle_id:"",
        block_time_limit_utc:"",
        block_type:"",
        block_reason:"",
        is_unlocked:"",
        unblock_by_user:"",
        created_date_utc: "",
      },
      showModalCreate: false,
      showModalDetail: false,
      allMerchants: [],
      rows: [],
      columns: [
        {
          label: "Action",
          name: "id",
          slot_name: "action_button",
        },
        {
          label: "Brand Code",
          name: "brand_code",
          sort: true,
        },
        {
          label: "Promo Id",
          name: "promo_id", 
        },  
        {
          label: "Promotion Type",
          name: "promotion_type", 
          slot_name: "promotion_type_column",
        },                           
        {
          label: "User Raffle Id",
          name: "user_raffle_id",
        },   
        {
          label: "Block Time Limit UTC",
          name: "block_time_limit_utc",
        },    
        {
          label: "Block Type",
          name: "block_type",
          sort: true,
        },  
        {
          label: "Block Reason",
          name: "block_reason",
        },  
        {
          label: "Is Unlocked",
          name: "is_unlocked",
          slot_name: "is_unlocked",
          sort: true,
        },  
        {
          label: "Unblock By User",
          name: "unblock_by_user",
        },  
        {
          label: "Created Date",
          name: "created_date_utc",
          sort: true,
        },
      ],
      config: {
        pagination: false,
        pagination_info: false,
        num_of_visibile_pagination_buttons: 8,
        per_page: this.itemPerPage ? this.itemPerPage : 50,
        checkbox_rows: true,
        highlight_row_hover: true,
        rows_selectable: true,
        multi_column_sort: true,
        card_mode: false,
        selected_rows_info: true,
        global_search: {
          visibility: false,
        },
        show_refresh_button: false,
        show_reset_button: false,
      },
      classes: {
        table: "table-striped table-bordered",
        row: {
          "my-row my-row2": true,
          "function-class": function (row) {
            return row.id == 1;
          },
        },
      },
    };
  },
  created() {
    this.mappingRole();
    let momNow = this.$moment(new Date().toUTCString());
    let filterEndDate = momNow.format("YYYY-MM-DD");
    let filterStartDate = momNow.add(-1, "months").format("YYYY-MM-DD");
    this.timeFilter.push(filterStartDate);
    this.timeFilter.push(filterEndDate);
    this.filter.start_date = filterStartDate;
    this.filter.end_date = filterEndDate;
    this.DateRangeModel = {
      start_date: filterStartDate,
      end_date: filterEndDate,
    };
    this.onLoadData();
    this.selectedItems.push(this.UPCConsumerBlockModel);
  },
  methods: {
    arrayPages() {
      var result = [];
      for (let index = 0; index < this.totalPages; index++) {
        result.push({ text: index + 1, value: index + 1 });
      }
      return result;
    },
    mappingRole() {
      let isChe = this.$store.getters.roleMappingData.some(object =>
        object.role.toLowerCase().includes('phche') &&
        object.menu.toLowerCase().includes('upcconsumerblockreport')
      );
      let isFortune = this.$store.getters.roleMappingData.some(object =>
        object.role.toLowerCase().includes('phft') ||
        object.role.toLowerCase().includes('fortune') &&
        object.menu.toLowerCase().includes('upcconsumerblockreport')
      );
      let isAdministrator = this.$store.getters.isLoginUserAdmin;
      this.brandCodeOption = [];
      if (isAdministrator || isChe)
      {
        this.brandCodeOption.push({ text: "Chesterfield", value: "PHChe" });
        this.BrandCodeModel = this.ChartBrandCodeModel = "PHChe";
        this.watch_brand_code = "PHChe";
      }

      if (isAdministrator || isFortune)
      {
        this.brandCodeOption.push({ text: "Fortune", value: "PHFortune" });
        this.BrandCodeModel = this.ChartBrandCodeModel = "PHFortune";
        this.watch_brand_code = "PHFortune";
      }

      this.is_allowed_unblock = this.$store.getters.roleMappingData.some(object =>
        object.function.toLowerCase().includes('unblockuserupc')
      ) || isAdministrator || this.$store.getters.isCheAdmin || this.$store.getters.isFortuneAdmin;
    },
    onResetFilter() {
      this.filter = {
        brand_code: this.BrandCodeModel,
        promo_id: "",
        promotion_type: "",
        user_raffle_id: "",
        start_date: this.DateRangeModel.start_date,
        end_date: this.DateRangeModel.end_date,
      };

      this.onLoadData();
      this.ValueFilterModel = "";
      this.PropertyFilterModel = "promo_id";
      this.ConditionFilterModel = "is";
    },
    onSearchFilter() {
      this.filter = {
        brand_code: this.BrandCodeModel,
        promo_id: "",
        promotion_type: this.PromotionTypeFilterModel,
        user_raffle_id: "",
        start_date: this.DateRangeModel.start_date,
        end_date: this.DateRangeModel.end_date,
      };
      switch (this.PropertyFilterModel) {
        case "promo_id":
          this.filter.promo_id = this.ValueFilterModel;
          break;
        case "promotion_type":
          this.filter.promotion_type = this.ValueFilterModel;
          break;
        case "user_raffle_id":
          this.filter.user_raffle_id = this.ValueFilterModel;
          break;   
        default:
          break;
      }
      this.onLoadData();
    },
    async onSearchExport() {
      this.onSearchFilter();
      NProgress.start();
      try {
        let response = await API.graphql({
          query: queries.exportUPCConsumerBlock,
          variables: {
            filter: this.filter,
            filename: "UPCConsumerBlock",
          },
        });
        var presign = response.data.exportUPCConsumerBlock;

        let date_ob = new Date();
        let date = ("0" + date_ob.getDate()).slice(-2);
        let month = ("0" + (date_ob.getMonth() + 1)).slice(-2);
        let year = date_ob.getFullYear();
        let minutes = date_ob.getMinutes();
        let second = date_ob.getSeconds();
        var filename= `UPCConsumerBlockReport_${year}-${month}-${date}-${minutes}${second}.csv`;
        
        axios
          .get(presign, { responseType: 'arraybuffer' })
          .then((response) => {
            const a = document.createElement("a");
            const blob = new Blob([response.data], { type: response.headers["content-type"] });
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = filename;
            a.click();
            console.log('end download');
          })

        NProgress.done();
        //document.location.href = presign;
      } catch (error) {
        console.log(error);
        NProgress.done();
      }
    },
    onDateFilterSubmit(value) {
      let momStart = this.$moment(new Date(value[0])).format("YYYY-MM-DD");
      let momEnd = this.$moment(new Date(value[1])).format("YYYY-MM-DD");
      this.filter.start_date = momStart;
      this.filter.end_date = momEnd;
      this.DateRangeModel = {
        start_date: momStart,
        end_date: momEnd,
      };
    },
    async onLoadData(selectedPage) {
      try {
        NProgress.start();
        
        var startDate = this.DateRangeModel.start_date + " 00:00:00";
        this.filter.start_date = this.$moment(
          new Date(startDate),
          "YYYY-MM-DD hh:mm:ss"
        ).utc();
        var endDate = this.DateRangeModel.end_date + " 23:59:59";
        this.filter.end_date = this.$moment(
          new Date(endDate),
          "YYYY-MM-DD hh:mm:ss"
        ).utc();

        this.filter.brand_code = this.BrandCodeModel;
        this.currentPage = selectedPage ? selectedPage : 1;
        let response = await API.graphql({
          query: queries.listUPCConsumerBlockPagination,
          variables: {
            pageSize: this.itemPerPage,
            pageNumber: this.currentPage,
            filter: this.filter,
          },
        });
        this.rows =
          response.data.listUPCConsumerBlockPagination.items;
        this.totalPages =
          response.data.listUPCConsumerBlockPagination.totalPages;
        this.totalItems =
          response.data.listUPCConsumerBlockPagination.totalItems;
        this.allTransaction = this.rows;
        NProgress.done();
      } catch (error) {
        NProgress.done();
        console.log(error);
      }
    },
    onSelectAllRow(payload) {
      this.selectedItems = payload.selected_items;
    },
    onSelectRow(payload) {
      this.showActionDetail = true;
      this.showActionDelete = true;
      this.selectedItems = payload.selected_items;
      if (
        payload.selected_items.length > 1 ||
        payload.selected_items.length == 0
      ) {
        this.showActionDetail = false;
      }
    },
    onDetailRow() {
      this.UPCConsumerBlockModel = this.allTransaction.filter(
        (x) => x.id === this.selectedItems[0].id
      )[0];
      this.showModalCreate = true;
      this.titlePopup = "Details";
    },
    disableUnlockButton(data){
      if(data.is_unlocked == true){
        return true;
      }
      return false;
    },
    unblockUser(id){
      api_loyalty
        .UPCUnBlockUser(this.BrandCodeModel, id)
        .then((data) => {
          console.log(data);
          if(data.isSuccess == true){
            this.message = {
              message: "unblock successful.",
              type: "success",
            };
          }else{
            this.message = {
              message: "unblock Failed." + data.message,
              type: "danger",
            };
          }
          //this.onRefreshData();
          this.onLoadData();
        })
        .catch((e) => {
          console.log(e);
          this.message = {
            message: "unblock Failed.",
            type: "danger",
          };
        });
    }
  },
  components: {
    VueBootstrap4Table,
  },
  watch: {
    PropertyFilterModel: function () {
      this.ConditionFilterModel = "is";
    },
    itemPerPage: function () {
      this.config.per_page = this.itemPerPage;
      this.onLoadData();
    },
    currentPage: function () {
      this.onLoadData(this.currentPage);
    },
  },
};
</script>
<style></style>
